import { theme, ProductColor } from '@aloft/toolkit-sui';

import { COMP_PIN_PATH } from './compPinPath.ts';

export const RankPinIcon = ({
  color,
  rank,
}: {
  color: ProductColor;
  rank?: number;
}) => (
  <svg
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path d={COMP_PIN_PATH} fill={theme.colors[color]} stroke="white" />
    {rank !== undefined && (
      <text
        x="9.5"
        y="10.2"
        textAnchor="middle"
        dominantBaseline="central"
        fill="white"
        fontSize={rank >= 10 ? 8 : 10}
        fontWeight="700"
      >
        {rank}
      </text>
    )}
  </svg>
);
